import React from 'react';
import FlowSummary, { IFlowSummary } from './FlowSummary';
import { Guid } from '@Shared.Angular/@types/guid';

type Props = {
  isMobile: boolean;
  groups: IFlowGroup[];
  onFlowClick: (flowId: Guid) => void;
};

const FlowGroups = ({ isMobile, groups, onFlowClick }: Props) => {
  return (
    <div className="flows-imin-group flow-groups">
      {groups?.map((group) => (
        <div
          key={group.groupName}
          className={`flow-block ${isMobile ? 'isMobile' : ''}`}
          data-flow-category={group.flowCategory}
        >
          <div className={`flow-block__header ${isMobile ? 'isMobile' : ''}`}>
            {group.groupName}
          </div>

          <div className={`flow-list ${isMobile ? 'isMobile' : ''}`}>
            <ul>
              {[...group.flows]
                .sort((a, b) => {
                  const dateA = new Date(a.dueDate).getTime() || 0;
                  const dateB = new Date(b.dueDate).getTime() || 0;
                  return dateA - dateB;
                })

                .map((flow) =>
                  flow.show === undefined || flow.show ? (
                    <li key={flow.flowId}>
                      <FlowSummary
                        isMobile={isMobile}
                        flow={flow}
                        onFlowClick={onFlowClick}
                      />
                    </li>
                  ) : null
                )}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FlowGroups;

export interface IFlowGroup {
  groupName: string;
  flowCategory: string;
  flows: IFlowGroupFlowSummary[];
}

export interface IFlowGroupFlowSummary extends IFlowSummary {
  dueDate: string;
  show?: boolean;
}
